import {
  BriefcaseSolidV6,
  BullhornRegularV6,
  HouseFlagSolidV6,
  MobileSignalOutSolidV6,
  UserGraduateSolidV6,
  AreaProCustomv6,
  OpenHouseSolidV6,
  RemineCustomV6,
  PhoneVolumeSolidV6,
  Inkedcustomv6,
} from "@shared/v2/Icomoon";

export const APP_ICONS_BY_LABEL = {
  marketer: { label: "Marketer", Icon: BullhornRegularV6, linkUrl: "/" },
  cma: { label: "CMA", Icon: HouseFlagSolidV6, linkUrl: "/" },
  recruiter: {
    label: "Recruiter.ai",
    Icon: BriefcaseSolidV6,
    linkUrl: "https://www.brivitymarketer.com/v2/recruiter",
  },
  remine: {
    label: "Remine",
    Icon: RemineCustomV6,
    linkUrl: "https://place.remine.com/?iss=https%3A%2F%2Fsso.brivity.com",
  },
  inked: {
    label: "Inked",
    Icon: Inkedcustomv6,
    linkUrl: "https://app.inked.com/",
  },
  textToLead: {
    label: "KWKLY",
    Icon: MobileSignalOutSolidV6,
    linkUrl: "https://app.kwkly.com/login.aspx",
  },
  reportCards: {
    label: "Report Cards",
    Icon: UserGraduateSolidV6,
    linkUrl: "https://learn.place.com/manage/reports/groups",
  },
  areaPro: {
    label: "AreaPro",
    Icon: AreaProCustomv6,
    linkUrl: "https://app.areapro.com/auto",
  },
  openHouses: {
    label: "Open Houses",
    Icon: OpenHouseSolidV6,
    linkUrl: "https://openhouse.brivity.com",
  },
  aiCallCoach: { label: "Gabbi Call IQ", Icon: PhoneVolumeSolidV6, linkUrl: "/launch/ai_call_coach" },
};

const { marketer, cma, recruiter, remine, inked, textToLead, areaPro, openHouses, aiCallCoach } =
  APP_ICONS_BY_LABEL;

export const OPTIONS_BY_LABEL = {
  [marketer.label]: "Brivity Marketer",
  // Need to change when we support support deep link > marketer.recruiter tab
  // [recruiter.label]: "Brivity Recruiter",
  // Might need this again
  // [designer.label]: "Brivity Designer",
  [cma.label]: "Brivity CMA",
};

export const OWNER_PLACE_RESOURCES = [
  openHouses,
  marketer,
  cma,
  recruiter,
  textToLead,
  areaPro,
  remine,
  inked,
];

export const AGENT_RESOURCES = [openHouses, marketer, cma, areaPro, remine, aiCallCoach];

export const AGENT_PLACE_RESOURCES = [openHouses, marketer, cma, areaPro, remine, inked];

export const OWNER_BRIVITY_RESOURCES = [openHouses, marketer, cma, textToLead, areaPro, remine, aiCallCoach];
